import React, { useState, useEffect } from "react";
import {
  Table,
  Collapse,
  Card,
  CardBody,
  CardTitle,
  Button,
  Row,
} from "reactstrap";
import SectionComponent from "../../Apps/Personalization/SectionComponent";
import SweetAlert from "react-bootstrap-sweetalert";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import Pagination from "../../../components/Paginationv3";
import ModalNewVehicle from "./ModalNewVehicle";
import ModalEditVehicle from "./ModalEditVehicle";
import ModalDuplicateVehicle from "./ModalDuplicateVehicle";
import ModalImportVehicle from "./ModalImportVehicle";
import ModalAllImports from "./ModalAllImports";
import { createVeiculoXlsx } from "./createVeiculoXlsx";
import useDebounce from "../../../utils/hooks/useDebounce";
import SearchFilters from "../../../components/SearchFilters";
import WaitExport from "../../../components/WaitExport";
import ModalEditStatus from "../DashboardLogistics/modalEditStatus";
import ModalListParticipants from "../DashboardLogistics/modalListParticipants";
import ModalListHistoric from "../DashboardLogistics/modalListHistoric";
import ActionButtonRounded from "../../../components/Buttons/ActionButtonRounded";
import IconButton from "../../../components/Buttons/IconButton";
import DeleteButton from "../../../components/Buttons/DeleteButton";

import {
  deleteVehicle,
  getAllVehicles,
  createVehicleStatus,
  reactivateVehicle,
} from "../../../utils/services/vehicles";
import LoadingSkelentonTable from "../../../components/loadingSkeletonTable";

function Vehicle(props) {
  const location = useLocation();
  const idEvent = location.state.idEvent;
  const [search, setSearch] = useState("");
  const [modalNewVehicle, setModalNewVehicle] = useState(false);
  const [modalEditVehicle, setModalEditVehicle] = useState(false);
  const [modalSurvey, setModalSurvey] = useState(false);
  const [modalSuperTela3, setModalSuperTela3] = useState(false);
  const [deleteData, setDeleteData] = useState({});
  const [confirm_alert, setconfirm_alert] = useState(false);
  const [success_dlg, setsuccess_dlg] = useState(false);
  // modais do dashboard
  const [modalEditaStatus, setModalEditStatus] = useState(false);
  const [modalHistoric, setModalHistoric] = useState(false);
  const [modalListParticipants, setModalListParticipants] = useState(false);
  const [vehicleSelected, setVehicleSelected] = useState(null);

  const [editData, setEditData] = useState({});
  const [duplicateData, setDuplicateData] = useState({});
  const [exportInProgress, setExportInProgress] = useState(false);
  const [finishExport, setFinishExport] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [countData, setCountData] = useState(0);
  const debouncedSearch = useDebounce(search, 300);

  const [vehicles, setVehicles] = useState([]);

  const [collapseIsOpen, setCollapseIsOpen] = useState(false);
  const [activeFilter, setActiveFilter] = useState("transfertype");
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenDuplicate, setIsOpenDuplicate] = useState(false);
  const [modalImportVeiculo, setModalImportVeiculo] = useState(false);

  const [status, setStatus] = useState(true);
  const [confirmAlertReactivate, setConfirmAlertReactivate] = useState(false);
  // state de carregamento da tabela
  const [loading, setLoading] = useState(false);

  const columnsFilter = [
    { name: "Tipo de Transfer", value: "transfertype", type: "text" },
    { name: "Nome", value: "description", type: "text" },
    { name: "Origem", value: "origin", type: "text" },
    { name: "Destino", value: "destination", type: "text" },
    { name: "Data Saída", value: "departureDateTime", type: "date" },
    { name: "Data Chegada", value: "arrivalDateTime", type: "date" },
    { name: "Status", value: "status", type: "text" },
  ];

  function setActiveFilterHandle(columnActive) {
    setActiveFilter(columnActive);
    setSearch("");
  }

  function toggleNewVehicle() {
    setModalNewVehicle(!modalNewVehicle);
    if (modalNewVehicle) {
      getAll();
    }
  }

  function toggleEditVehicle() {
    setModalEditVehicle(!modalEditVehicle);
    if (modalEditVehicle) {
      getAll();
    }
  }
  function toggleDuplicateVehicle() {
    setIsOpenDuplicate(!isOpenDuplicate);
    if (isOpenDuplicate) {
      getAll();
    }
  }

  async function delVehicle() {
    if (deleteData?.id) {
      await deleteVehicle(deleteData.id).then((res) => {
        if (res.message === "deleted") {
          setconfirm_alert(false);
          setsuccess_dlg(true);
        }
      });
    }
  }
  const reverseDate = () => {
    const reverse = debouncedSearch
      .split("/")
      .reverse()
      .join("/")
      .replace(/\//g, "-");
    return reverse;
  };
  function treatmentSearch() {
    if (
      columnsFilter.filter((item) => item.value === activeFilter)[0].type ===
      "date"
    ) {
      return reverseDate();
    }
    return debouncedSearch;
  }
  function getAll() {
    setLoading(true);
    getAllVehicles(
      idEvent,
      currentIndex,
      itemsPerPage,
      treatmentSearch(),
      activeFilter,
      status,
    ).then((res) => {
      if (res.data.message === "FOUND") {
        setVehicles(res.data.findAll.data);
        setCountData(res.data.findAll.count);
      }
      setLoading(false);
    });
  }

  async function changeStatusVehicle(newStatus, notes) {
    const data = {
      eventId: idEvent,
      vehicleId: vehicleSelected.id,
      previousStatus: vehicleSelected.status,
      newStatus: newStatus,
      notes: notes || "",
    };

    await createVehicleStatus(data).then((res) => {
      // if (res.data.message === "created") {
      getAll();
      setVehicleSelected(null);
      // }
    });
  }

  const formatDate = (date) => {
    if (!date) return "";
    const formatedDate = date.split("T")[0].split("-").reverse().join("-");
    if (date.split("T")[0].includes("1969")) return "";
    const time = date.split("T")[1].substring(0, 5);
    return `${formatedDate.replaceAll("-", "/")} ${time}`;
  };

  async function getColorStatus(status) {
    if (!status) return;

    switch (status) {
      case "Finalizado":
        return "#28a745";

      case "Programado":
        return "#3300ff";

      case "Em Trânsito":
        return "#bbff00";

      case "Cancelados":
        return "#ff3c3c";

      default:
        return "#ffffffff";
    }
  }

  useEffect(() => {
    getAll();
  }, [currentIndex, itemsPerPage, debouncedSearch, status]);

  async function confirmReactivate() {
    var formData = await reactivateVehicle(vehicleSelected.id);

    if (formData.message === "VEHICLE_REACTIVATED") {
      setConfirmAlertReactivate(false);
      setsuccess_dlg(true);
      setdynamic_title("Reativado");
      setdynamic_description("Veículo reativado");

      getAll();
    }
  }

  return (
    <>
      {confirmAlertReactivate ? (
        <SweetAlert
          title={`Deseja Reativar ${vehicleSelected.description}?`}
          warning
          showCancel
          confirmBtnText="Sim"
          cancelBtnText="Não"
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          onConfirm={() => {
            confirmReactivate();
          }}
          onCancel={() => setConfirmAlertReactivate(false)}
        >
          {/* Você não poderá reverter essa ação. */}
          <a></a>
        </SweetAlert>
      ) : null}

      {modalEditaStatus && (
        <ModalEditStatus
          isOpen={modalEditaStatus}
          toggle={() => {
            setVehicleSelected(null);
            setModalEditStatus(false);
          }}
          changeStatus={changeStatusVehicle}
          data={vehicleSelected}
        />
      )}

      {modalListParticipants && (
        <ModalListParticipants
          isOpen={modalListParticipants}
          toggle={() => {
            getAll();
            setVehicleSelected(null);
            setModalListParticipants(false);
          }}
          data={vehicleSelected}
          getAllVehicles={getAll}
        />
      )}

      {modalHistoric && (
        <ModalListHistoric
          isOpen={modalHistoric}
          toggle={() => setModalHistoric(false)}
          data={vehicleSelected}
        />
      )}

      {modalNewVehicle && (
        <ModalNewVehicle
          isOpen={modalNewVehicle}
          toggle={toggleNewVehicle}
          idEvent={idEvent}
          getAllVehicles={getAll}
        />
      )}
      {modalEditVehicle && (
        <ModalEditVehicle
          isOpen={modalEditVehicle}
          toggle={toggleEditVehicle}
          idEvent={idEvent}
          data={editData}
          getAllVehicles={getAll}
        />
      )}
      {modalImportVeiculo && (
        <ModalAllImports
          isOpen={modalImportVeiculo}
          toggle={() => setModalImportVeiculo(!modalImportVeiculo)}
          eventId={idEvent}
          getAllVehiclesFunc={getAll}
        />
      )}

      {isOpenDuplicate && (
        <ModalDuplicateVehicle
          isOpen={isOpenDuplicate}
          toggle={toggleDuplicateVehicle}
          idEvent={idEvent}
          data={duplicateData}
          getAllVehicles={getAll}
        />
      )}

      {confirm_alert ? (
        <SweetAlert
          title={`Deseja deletar o Veículo ${deleteData.description}?`}
          warning
          showCancel
          confirmBtnText="Sim"
          cancelBtnText="Não"
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          onConfirm={() => {
            delVehicle();
          }}
          onCancel={() => setconfirm_alert(false)}
        >
          Você não poderá reverter essa ação!
        </SweetAlert>
      ) : null}

      {success_dlg ? (
        <SweetAlert
          success
          title="Sucesso"
          onConfirm={() => {
            getAll();
            setsuccess_dlg(false);
          }}
        >
          Veículo deletado com sucesso
        </SweetAlert>
      ) : null}
      <WaitExport
        isOpen={exportInProgress}
        name="Veículos"
        preposicao="dos"
        finishExport={finishExport}
        setFinishExport={setFinishExport}
        setExportInProgress={setExportInProgress}
      />
      <Card>
        <CardBody>
          <CardTitle>Veículos</CardTitle>
          <div>
            <Row
              style={{
                display: "flex",
                flexDirection: "row",
                marginBottom: 10,
                width: "50px",
              }}
            >
              <SectionComponent
                sectionName="Filtros"
                setIsOpen={setCollapseIsOpen}
                isOpen={collapseIsOpen}
              />
            </Row>
            <Collapse isOpen={collapseIsOpen}>
              <SearchFilters
                columns={columnsFilter}
                activeFilter={activeFilter}
                setActiveFilterHandle={setActiveFilterHandle}
              />
            </Collapse>
          </div>
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
              margin: "10px 0",
            }}
          >
            <form
              className="app-search d-none d-lg-block events-input-search"
              onSubmit={(e) => e.preventDefault()}
            >
              <div className="position-relative">
                <input
                  type={
                    activeFilter === "departureDateTime" ||
                    activeFilter === "arrivalDateTime"
                      ? "date"
                      : "text"
                  }
                  value={search}
                  className="form-control"
                  placeholder="Pesquisar..."
                  onChange={(e) => setSearch(e.target.value)}
                />
                <span className="bx bx-search-alt" />
              </div>
            </form>

            <div className="mobile-btn-section" style={{ width: "100%" }}>
              <Row className="mobile-btns-top">
                <form
                  className="app-search"
                  style={{ padding: "0px" }}
                  onSubmit={(e) => e.preventDefault()}
                >
                  <div className="position-relative">
                    <input
                      type={
                        activeFilter === "departureDateTime" ||
                        activeFilter === "arrivalDateTime"
                          ? "date"
                          : "text"
                      }
                      value={search}
                      className="form-control"
                      placeholder="Pesquisar..."
                      onChange={(e) => setSearch(e.target.value)}
                    />
                    <span className="bx bx-search-alt" />
                  </div>
                </form>
              </Row>
              <SectionComponent
                sectionName="Opções"
                setIsOpen={setIsOpen}
                isOpen={isOpen}
              />
              <Collapse isOpen={isOpen}>
                <Row className="mobile-btns-top">
                  <div
                    onClick={() =>
                      createVeiculoXlsx({
                        jwt: props.state.global_user_data.data.token,
                        idEvent: idEvent,
                        limit: 100,
                        countData,
                        setFinishExport,
                      }) > setExportInProgress(true)
                    }
                  >
                    Exportar Veículo
                  </div>
                </Row>

                <ActionButtonRounded
                  title="Importar Veículos"
                  onClick={() => setModalImportVeiculo(true)}
                  type="mobile"
                />

                <ActionButtonRounded
                  title="Adicionar Veículo"
                  onClick={() => setModalNewVehicle(true)}
                  type="mobile"
                />
              </Collapse>
            </div>

            <div className="header-btns-container">
              <Button
                color="secondary"
                className="btn-rounded waves-effect waves-light events-button-add-lg"
                onClick={() => {
                  // setTransition(true);
                  setStatus(!status);
                }}
              >
                {!status ? "Filtrar: Ativos" : "Filtrar: Inativos"}
              </Button>

              {vehicles?.length > 0 && (
                <Button
                  color="success"
                  className="btn-rounded waves-effect waves-light events-button-add"
                  onClick={() =>
                    createVeiculoXlsx({
                      jwt: props.state.global_user_data.data.token,
                      idEvent: idEvent,
                      limit: 100,
                      countData,
                      setFinishExport,
                    }) > setExportInProgress(true)
                  }
                >
                  Exportar Veículo
                </Button>
              )}
              <ActionButtonRounded
                title="Importar Veículos"
                onClick={() => setModalImportVeiculo(true)}
                margin={"0 10px"}
                classTips="show-tips-v2"
                tooltip={
                  "Importadores para Adicionar, Editar ou Excluir veículos"
                }
                id="btn-importar-veiculo"
              />

              <ActionButtonRounded
                title="Adicionar Veículo"
                onClick={() => setModalNewVehicle(true)}
              />
            </div>
          </div>

          <div className="table-responsive">
            <Table className="table mb-0">
              <thead className="table-light">
                <tr>
                  <th style={{ width: "15%" }}>Tipo de Transfer</th>
                  <th style={{ width: "20%" }}>Nome</th>
                  <th style={{ width: "15%" }}>Origem</th>
                  <th style={{ width: "15%" }}>Destino</th>
                  <th style={{ width: "15%" }}>Data Saída</th>
                  <th style={{ width: "15%" }}>Data Chegada</th>
                  <th style={{ width: "15%" }}>Status</th>
                  <th style={{ width: "5%" }}>Utilizado/Capacidade</th>
                  <th style={{ width: "15%" }}>Ações</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <LoadingSkelentonTable lines={10} cols={9} />
                ) : (
                  vehicles.length > 0 &&
                  vehicles.map((e, i) => (
                    <tr>
                      <td>{e.transferType}</td>
                      <td>{e.description}</td>
                      <td>{e.origin}</td>
                      <td>{e.destination}</td>
                      <td>{formatDate(e.departureDatetime)}</td>
                      <td>{formatDate(e.arrivalDatetime)}</td>
                      <td>
                        <a
                          style={{
                            backgroundColor:
                              e.status === "Finalizado"
                                ? "#28a745"
                                : e.status === "Programado"
                                  ? "#3300ff"
                                  : e.status === "Em Trânsito"
                                    ? "#bbff00"
                                    : e.status === "Cancelado"
                                      ? "#ff3c3c"
                                      : e.status === "Embarcando"
                                        ? "purple"
                                        : "",
                            padding: 5,
                            borderRadius: 10,
                            color:
                              e.status === "Em Trânsito" ? "black" : "white",
                            width: 85,
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          {e.status}
                        </a>
                      </td>
                      <td style={{ textAlign: "center" }}>
                        <span
                          className="tagDriver"
                          style={{
                            whiteSpace: "nowrap",
                            backgroundColor:
                              e.amount === 0
                                ? "red"
                                : e.amount > 0 && e.amount < e.seatingCapacity
                                  ? "orange"
                                  : "green",
                          }}
                        >
                          {e.amount}
                        </span>
                        de{" "}
                        <span
                          className="tagDriver"
                          style={{
                            whiteSpace: "nowrap",
                            backgroundColor: "green",
                          }}
                        >
                          {e.seatingCapacity}
                        </span>
                      </td>
                      {status && (
                        <td>
                          <i
                            className="mdi mdi-pencil"
                            style={{
                              color: "green",
                              fontSize: 17,
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setEditData(e);
                              setModalEditVehicle(true);
                            }}
                            title="Editar"
                          />
                          <IconButton
                            title="Duplicar Veículo"
                            className="mdi mdi-content-duplicate"
                            color="gray"
                            action="C"
                            onClick={() => {
                              setDuplicateData(e);
                              setIsOpenDuplicate(true);
                            }}
                          />{" "}
                          <DeleteButton
                            cursor={
                              e.status !== "Programado" ? "auto " : "pointer"
                            }
                            color={
                              e.status !== "Programado" ? "lightgray" : "red"
                            }
                            onClick={() => {
                              if (e.status !== "Programado") {
                                return;
                              }
                              setDeleteData(e);
                              setconfirm_alert(true);
                            }}
                          />
                          <i
                            className="dripicons-user-group"
                            title="Participantes por veículo"
                            style={{
                              color: "blue",
                              fontSize: 17,
                              cursor: "pointer",
                              marginRight: 5,
                            }}
                            onClick={() => {
                              setVehicleSelected(e);
                              setModalListParticipants(true);
                            }}
                          />
                          <IconButton
                            title="Alterar Status"
                            className="mdi mdi-car-arrow-right"
                            color="green"
                            action="C"
                            onClick={() => {
                              setVehicleSelected(e);
                              setModalEditStatus(true);
                            }}
                          />
                          <i
                            className="mdi mdi-note"
                            title="Histórico do veículo"
                            style={{
                              marginLeft: "5px",
                              color: "blue",
                              fontSize: 17,
                              cursor: "pointer",
                              fontSize: 17,
                            }}
                            onClick={() => {
                              setVehicleSelected(e);
                              setModalHistoric(true);
                            }}
                          />
                        </td>
                      )}

                      {!status && (
                        <td>
                          <IconButton
                            className="mdi mdi-account-reactivate"
                            action="U"
                            color="green"
                            onClick={() => {
                              setVehicleSelected(e);
                              setConfirmAlertReactivate(true);
                            }}
                          />
                        </td>
                      )}
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>
      <div className="bottom-navigation" style={{ justifyContent: "flex-end" }}>
        <Pagination
          data={vehicles}
          search={search}
          currentIndex={currentIndex}
          setCurrentIndex={setCurrentIndex}
          countData={countData}
          maxItemPerPage={itemsPerPage}
          setMaxItemPerPage={setItemsPerPage}
          maxPageButtonsToShow={3}
        />
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return { state };
};

export default connect(mapStateToProps)(Vehicle);
